import React from 'react';
import { Box, Skeleton, useTheme } from '@ublend-npm/aulaui-core';

const StarredSpaceSkeleton = () => {
  const { palette } = useTheme();
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      p={1.5}
      borderRadius={2}
      bgcolor={palette.action?.hover || 'rgba(0, 0, 0, 0.04)'}
    >
      <Box display="flex" alignItems="center" gap={2}>
        <Skeleton kind="circular" width={40} height={40} />
        <Box>
          <Skeleton kind="text" width={120} height={24} />
          <Skeleton kind="text" width={80} height={20} />
        </Box>
      </Box>
      <Skeleton kind="circular" width={24} height={24} />
    </Box>
  );
};

export default StarredSpaceSkeleton;
